import { useState } from 'react';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav('#home'); }}
          className="flex items-center cursor-pointer group"
        >
          <img
            src="https://storage.readdy-site.link/project_files/1a9a4500-7279-4f03-ae00-42acc8365d9b/6faaf775-79cf-4bf6-a10f-57d421b38cd4_cropped-AIR-TEK-logo-.jpg?v=f784fa9615b2f2704d57680a9749563d"
            alt="Air-Tek NC Logo"
            className="h-14 w-auto object-contain group-hover:opacity-90 transition-opacity duration-200"
          />
        </a>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="tel:9193489399"
            className="flex items-center gap-2 text-[#0a1628] hover:text-[#0066aa] font-bold transition-colors duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontSize: '1.35rem' }}
          >
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-phone-fill text-[#0066aa] text-xl" />
            </div>
            (919) 348-9399
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="bg-[#0066aa] hover:bg-[#005590] text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Request Service
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center text-[#0a1628] cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-5">
          <div className="flex flex-col gap-4">
            <a
              href="tel:9193489399"
              className="flex items-center gap-2 text-[#0a1628] font-bold text-lg cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-fill text-[#0066aa]" />
              </div>
              (919) 348-9399
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
              className="bg-[#0066aa] text-white font-bold text-sm px-5 py-3 rounded-full text-center cursor-pointer"
            >
              Request Service
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
